export default __webpack_public_path__ + "static/media/logo.5dbad9e0.png";